module.exports = __webpack_public_path__ + "media/images/lb/849-9221f499d6ae2febac15c16903f5f56d.svg";